import { Laptop, Smartphone, Tablet } from "lucide-react";

export const F = { fontFamily: "'Cabinet Grotesk', sans-serif" };
export const HERO = "https://images.unsplash.com/photo-1758598306535-93877d73892d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
export const STATUS = {
  submitted: ["Submitted", "bg-slate-100 text-slate-700 border-slate-300"],
  reviewing: ["Reviewing", "bg-blue-50 text-blue-700 border-blue-200"],
  interview: ["Interview", "bg-amber-50 text-amber-800 border-amber-300"],
  hired: ["Hired", "bg-emerald-50 text-emerald-700 border-emerald-300"],
  not_hired: ["Not hired", "bg-red-50 text-red-700 border-red-200"],
};
export const STEPS = ["submitted", "reviewing", "interview", "hired"];

export const StatusPill = ({ s, testId }) => <span className={`text-[11px] font-bold uppercase tracking-wide px-2.5 py-0.5 rounded-full border ${STATUS[s]?.[1]}`} data-testid={testId}>{STATUS[s]?.[0] || s}</span>;

export const PayBadge = ({ j }) => (
  <span className={`inline-block text-xs font-bold px-3 py-1 rounded-full ${j.pay_type === "hourly_commission" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-900"}`} data-testid={`pay-${j.slug}`}>
    {j.pay_type === "hourly_commission" ? "Hourly + commission" : "Commission only"}
  </span>
);

const DEV = { computer: [Laptop, "Computer"], phone: [Smartphone, "Phone"], tablet: [Tablet, "Tablet"] };
export const Devices = ({ list = [], dark }) => (
  <div className="flex flex-wrap gap-2">{list.map(d => { const [I, l] = DEV[d] || []; return I && <span key={d} className={`flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full ${dark ? "bg-white/10 text-white" : "bg-slate-100 text-slate-700"}`}><I className="w-3.5 h-3.5" />{l}</span>; })}</div>
);
export const DEVICE_OPTIONS = Object.entries(DEV).map(([k, [I, l]]) => ({ k, I, l }));

export const CShell = ({ children, testId }) => <div className="pt-20 pb-20 min-h-screen bg-[#f6f5f1]" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }} data-testid={testId}><div className="max-w-6xl mx-auto px-4 space-y-8">{children}</div></div>;

export const fmtDate = (s) => s ? new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "";
